import { createContext, useContext } from 'react';

import {
	IConfigsCompany,
	IModulesPermissionsUser,
	IPermissionsPagesUser,
	IUserAttributes,
} from './models/globalContextModels';

interface IGlobalContextProps {
	routes: any;
	pathCompanyName: string | undefined;
	userAttributes: any;
	permissionsPage: IPermissionsPagesUser | [];
	modulesPermissions: IModulesPermissionsUser | [];
	setUserAttributes: React.Dispatch<React.SetStateAction<IUserAttributes>>;
	userInfos: { [key: string]: string | number | boolean };
	setUserInfos: React.Dispatch<
		React.SetStateAction<{ [key: string]: string | number | boolean }>
	>;
	configsCompany: IConfigsCompany;
	refreshPermissions: () => void;
}
export const GlobalContext = createContext({} as IGlobalContextProps);

export const useGlobalContext = () => useContext(GlobalContext);
